import { Box } from "@material-ui/core";
import {
  HIMAWARI_TYPE_IRHT, HIMAWARI_TYPE_IRHT_COLOR,
  HIMAWARI_TYPE_IRTP, HIMAWARI_TYPE_IRTP_COLOR,
  HIMAWARI_TYPE_VAA,
  HIMAWARI_TYPE_CB,
  HIMAWARI_TYPE_IRDIFF,
} from "../layers/Himawari";
import { useTranslation } from "react-i18next";
import { LegendBoxContentsName, LegendBoxList, LegendCssIcoListItem, LegendCssSquareIconListItem, LegendListDivider } from "../../legend/LegendBoxComponents";
import { himawariTypeState } from "../../../store/HimawariTypeState";
import { useRecoilValue } from "recoil";
import { memo } from "react";

function LegendHimawari() {
  const type = useRecoilValue(himawariTypeState);

  const getLegendComponent = (type) => {
    switch (type.dataType) {
      case HIMAWARI_TYPE_IRHT_COLOR:
        return <LegendBoxIrhtColor dataType={type.dataType}/>;
      case HIMAWARI_TYPE_IRHT:
      case HIMAWARI_TYPE_CB:
        return <LegendBoxIrht dataType={type.dataType}/>
      case HIMAWARI_TYPE_IRTP_COLOR:
        return <LegendBoxIrtpColor dataType={type.dataType}/>
      case HIMAWARI_TYPE_IRTP:
        return <LegendBoxIrtp dataType={type.dataType}/>
      default:
        return null
    }
  };
  return (
    <Box>
      <LegendBoxHimawariTitle areaType={type.areaType} dataType={type.dataType}></LegendBoxHimawariTitle>
      {
        getLegendComponent(type)
      }
    </Box>
  )
}

function LegendBoxHimawariTitle(props) {
  let { areaType, dataType } = props;
  const {t} = useTranslation();
  let unit = "";
  switch(dataType) {
    case HIMAWARI_TYPE_IRHT_COLOR:
      dataType = "IRHT(Color)";
      unit = "(ft)";
      break;
    case HIMAWARI_TYPE_IRHT:
      unit = "(ft)";
      break;
    case HIMAWARI_TYPE_IRTP_COLOR:
      dataType = "IRTP(Color)";
      unit = "(°C)";
      break;
    case HIMAWARI_TYPE_IRTP:
      unit = "(°C)";
      break;
    case HIMAWARI_TYPE_CB:
      unit = "(ft)";
      break;
    case HIMAWARI_TYPE_VAA:
      dataType = "VAA";
      break;
    case HIMAWARI_TYPE_IRDIFF:
      dataType = "IR diff";
      break;
    default:
      break;
  }
  return (
    <Box sx={{display: "flex", minWidth: 182}}>
      <LegendBoxContentsName>{t(areaType)}</LegendBoxContentsName>
      <Box sx={{width: 10}}></Box>
      <LegendBoxContentsName>{t(dataType)} {unit}</LegendBoxContentsName>
    </Box>
  )
}

function LegendBoxIrhtColor({dataType}) {
  const display = dataType !== HIMAWARI_TYPE_IRHT_COLOR ? "none" : "flex";
  return (
    <Box sx={{display: display}}>
      <LegendBoxList>
        <LegendCssSquareIconListItem background={'rgba(212, 0, 0, 0.6)'} text={<>45,000</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(223, 102, 102, 0.6)'} text={<>40,000</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255, 255, 0, 0.6)'} text={<>35,000</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(193, 210, 87, 0.6)'} text={<>30,000</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255,255,255,0.612)'} text={<>25,000</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255,255,255,0.478)'} text={<>20,000</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255,255,255,0.427)'} text={<>17,500</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255,255,255,0.361)'} text={<>15,000</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255,255,255,0.298)'} text={<>12,500</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255,255,255,0.231)'} text={<>10,000</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255,255,255,0.18)'} text={<>7,500</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255,255,255,0.114)'} text={<>5,000</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255,255,255,0.051)'} text={<>2,500</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255,255,255,0)'} text={<>0</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
      </LegendBoxList>
    </Box>
  )
}

function LegendBoxIrht({dataType}) {
  const {t} = useTranslation();
  const display = dataType !== HIMAWARI_TYPE_IRHT && dataType !== HIMAWARI_TYPE_CB ? "none" : "";
  const cbDisplay = dataType === HIMAWARI_TYPE_CB;
  return (
    <Box sx={{display: display}}>
      <LegendBoxList width={65}>
        <LegendCssSquareIconListItem background={'rgba(255,255,255,0.976)'} text={<>45,000</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255,255,255,0.976)'} text={<>40,000</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255,255,255,0.859)'} text={<>35,000</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255,255,255,0.725)'} text={<>30,000</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255,255,255,0.612)'} text={<>25,000</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255,255,255,0.478)'} text={<>20,000</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255,255,255,0.427)'} text={<>17,500</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255,255,255,0.361)'} text={<>15,000</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255,255,255,0.298)'} text={<>12,500</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255,255,255,0.231)'} text={<>10,000</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255,255,255,0.18)'} text={<>7,500</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255,255,255,0.114)'} text={<>5,000</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255,255,255,0.051)'} text={<>2,500</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255,255,255,0)'} text={<>0</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
      </LegendBoxList>
      {
        cbDisplay && (
          <>
            <Box sx={{height: 5}}></Box>
            <LegendBoxList>
              <LegendCssIcoListItem background={'rgba(255,0,0, 1)'} text={<>{t('CB AREA')}</>}></LegendCssIcoListItem>
              <LegendCssIcoListItem background={'rgba(0,255,0, 1)'} text={<>{t('CB DEV')}</>}></LegendCssIcoListItem>
            </LegendBoxList>
          </>
        )
      }
    </Box>
  )
}

function LegendBoxIrtpColor({dataType}) {
  const display = dataType !== HIMAWARI_TYPE_IRTP_COLOR ? "none" : "flex";
  return (
    <Box sx={{display: display}}>
      <LegendBoxList>
        <LegendCssSquareIconListItem background={'rgba(0, 0, 0, 0.6)'} text={<>-69</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(212, 0, 0, 0.6)'} text={<>-61</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(223, 102, 102, 0.6)'} text={<>-53</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255, 255, 0, 0.6)'} text={<>-44</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(193, 210, 87, 0.6)'} text={<>-36</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255, 255, 255, 0.53)'} text={<>-26</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255, 255, 255, 0.4)'} text={<>-17</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255, 255, 255, 0.27)'} text={<>-13</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255, 255, 255, 0.23)'} text={<>-8</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255, 255, 255, 0.2)'} text={<>-4</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255, 255, 255, 0.16)'} text={<>0</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255, 255, 255, 0.13)'} text={<>5</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255, 255, 255, 0.1)'} text={<>9</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255, 255, 255, 0.07)'} text={<>14</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255, 255, 255, 0.03)'} text={<>18</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255, 255, 255, 0)'} text={<></>}></LegendCssSquareIconListItem>
      </LegendBoxList>
    </Box>
  )
}

function LegendBoxIrtp({dataType}) {
  const display = dataType !== HIMAWARI_TYPE_IRTP ? "none" : "flex";
  return (
    <Box sx={{display: display}}>
      <LegendBoxList>
        <LegendCssSquareIconListItem background={'rgba(255, 255, 255, 0.99)'} text={<>-69</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255, 255, 255, 0.976)'} text={<>-61</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255, 255, 255, 0.976)'} text={<>-53</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255, 255, 255, 0.812)'} text={<>-44</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255, 255, 255, 0.706)'} text={<>-36</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255, 255, 255, 0.616)'} text={<>-26</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255, 255, 255, 0.502)'} text={<>-17</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255, 255, 255, 0.4)'} text={<>-13</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255, 255, 255, 0.275)'} text={<>-8</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255, 255, 255, 0.173)'} text={<>-4</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255, 255, 255, 0.11)'} text={<>0</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255, 255, 255, 0.059)'} text={<>5</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255, 255, 255, 0.008)'} text={<>9</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255, 255, 255, 0.)'} text={<>14</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255, 255, 255, 0.)'} text={<>18</>}></LegendCssSquareIconListItem>
        <LegendListDivider />
        <LegendCssSquareIconListItem background={'rgba(255, 255, 255, 0)'} text={<></>}></LegendCssSquareIconListItem>
      </LegendBoxList>
    </Box>
  )
}
export default memo(LegendHimawari);